import moveRoutes from './routes'

/* @ngInject */
const moveRun = (
  $transitions,
  storageHandler,
  $$wagon,
  $$railway,
  $$area,
  $state,
  maneuverMenu,
) => {
  $transitions.onSuccess({
    entering: moveRoutes.index.path,
  }, (trans) => {
    maneuverMenu.radio.value = 'moveMenu'

    const step = storageHandler.get('maneuver.move.step')

    if (step === 'selectWagons') {
      $state.go(moveRoutes.selectWagons.path)
    } else if (step === 'selectRailway') {
      $state.go(moveRoutes.selectRailway.path)
    } else if (step === 'report') {
      $state.go(moveRoutes.report.path)
    } else if (!step) {
      $state.go(moveRoutes.selectWagons.path)
    }
  })

  $transitions.onSuccess({
    entering: moveRoutes.selectWagons.path,
  }, (trans) => {
    if (storageHandler.get('maneuver.move.mySelectedWagons')) {
      $$wagon.data.mySelectedWagons = storageHandler.get('maneuver.move.mySelectedWagons')
    } else {
      $$wagon.data.mySelectedWagons.splice(0, $$wagon.data.mySelectedWagons.length)
    }

    if (storageHandler.get('maneuver.move.mySearchedWagons')) {
      $$wagon.data.mySearchedWagons = storageHandler.get('maneuver.move.mySearchedWagons')
    } else {
      $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    }

    if (storageHandler.get('maneuver.move.mySelectedIds')) {
      $$wagon.data.mySelectedIds = storageHandler.get('maneuver.move.mySelectedIds')
    } else {
      $$wagon.data.mySelectedIds.splice(0, $$wagon.data.mySelectedIds.length)
    }

    if (storageHandler.get('maneuver.move.mySelectedLength')) {
      $$wagon.data.mySelectedLength = storageHandler.get('maneuver.move.mySelectedLength')
    } else {
      $$wagon.data.mySelectedLength = 0
    }

    if (storageHandler.get('maneuver.move.myWagonSearchdata')) {
      $$wagon.data.myWagonSearchdata = storageHandler.get('maneuver.move.myWagonSearchdata')
    } else {
      $$wagon.data.myWagonSearchdata = $$wagon.new.search()
    }
  })

  $transitions.onBefore({
    exiting: moveRoutes.selectWagons.path,
  }, (trans) => {
    storageHandler.save('maneuver.move.mySearchedWagons', $$wagon.data.mySearchedWagons)
    storageHandler.save('maneuver.move.mySelectedWagons', $$wagon.data.mySelectedWagons)
    storageHandler.save('maneuver.move.mySelectedIds', $$wagon.data.mySelectedIds)
    storageHandler.save('maneuver.move.mySelectedLength', $$wagon.data.mySelectedLength)
    storageHandler.save('maneuver.move.myWagonSearchdata', $$wagon.data.myWagonSearchdata || {})
    storageHandler.save('maneuver.move.step', 'selectWagons')

    $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    // $$wagon.data.mySelectedWagons.splice(0, $$wagon.data.mySelectedWagons.length)
    $$wagon.data.mySelectedIds.splice(0, $$wagon.data.mySelectedIds.length)
    $$wagon.data.mySelectedLength = 0
    $$wagon.data.myWagonSearchdata = {}
  })

  $transitions.onSuccess({
    entering: moveRoutes.selectRailway.path,
  }, (trans) => {
    if (storageHandler.get('maneuver.move.myArea')) {
      $$area.data.dest = storageHandler.get('maneuver.move.myArea')
    } else {
      $$wagon.data.dest = $$area.new()
    }

    if (storageHandler.get('maneuver.move.myRailway')) {
      $$railway.data.dest = storageHandler.get('maneuver.move.myRailway')
    } else {
      $$wagon.data.dest = $$railway.new()
    }

    if (storageHandler.get('maneuver.move.mySelectedIds')) {
      $$wagon.data.mySelectedIds = storageHandler.get('maneuver.move.mySelectedIds')
    } else {
      $$wagon.data.mySelectedIds.splice(0, $$wagon.data.mySelectedIds.length)
    }

    if (storageHandler.get('maneuver.move.mySelectedLength')) {
      $$wagon.data.mySelectedLength = storageHandler.get('maneuver.move.mySelectedLength')
    } else {
      $$wagon.data.mySelectedLength = 0
    }
  })

  $transitions.onBefore({
    exiting: moveRoutes.selectRailway.path,
  }, (trans) => {
    storageHandler.save('maneuver.move.myArea', $$area.data.dest)
    storageHandler.save('maneuver.move.myRailway', $$railway.data.dest)
    storageHandler.save('maneuver.move.step', 'selectRailway')
    $$area.data.dest = null
    $$railway.data.dest = null
  })

  $transitions.onSuccess({
    entering: moveRoutes.report.path,
  }, async (trans) => {
    $$wagon.data.myWagonIds.splice(0, $$wagon.data.myWagonIds.length)
    $$wagon.data.mySelectedWagons.splice(0, $$wagon.data.mySelectedWagons.length)
    $$wagon.data.mySelectedIds.splice(0, $$wagon.data.mySelectedIds.length)
    $$wagon.data.mySelectedLength = 0
    $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)

    storageHandler.save('maneuver.move.myWagonIds', [])
    storageHandler.save('maneuver.move.mySelectedWagons', [])
    storageHandler.save('maneuver.move.mySelectedIds', [])
    storageHandler.save('maneuver.move.mySelectedLength', [])
    storageHandler.save('maneuver.move.mySearchedWagons', [])

    const id = storageHandler.get('maneuver.move.myRailway').id
    if (id) {
      $$railway.data.dest = await $$railway.request.getById(id)
      $$railway.data.dest.myWagons = await $$wagon.request.getByRailway(id)
    }
  })

  $transitions.onBefore({
    exiting: moveRoutes.report.path,
  }, (trans) => {
    storageHandler.save('maneuver.move.myRailway', $$railway.data.dest)
    storageHandler.save('maneuver.move.step', 'report')
    storageHandler.save('maneuver.move.mySearchedWagons', [])
    storageHandler.save('maneuver.move.mySelectedWagons', [])
    storageHandler.save('maneuver.move.mySelectedIds', [])
    storageHandler.save('maneuver.move.myArea', $$area.new())
    storageHandler.save('maneuver.move.myRailway', $$railway.new())
    $$railway.data.dest = null
  })
}

export default moveRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/move/move.run.js